import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'

import App from './App.vue'
import router from './router'
import store from './store'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faThermometerThreeQuarters, faAngleLeft, faAngleRight, faPlay, faPause,
  faNewspaper, faBell, faSave, faCog, faHeart
} from '@fortawesome/free-solid-svg-icons'

import {
  faTwitter
} from '@fortawesome/free-brands-svg-icons'

import './registerServiceWorker'

import temperature from './filters/temperature'
import volume from './filters/volume'
import weight from './filters/weight'

import '../node_modules/bulma/bulma.sass'
import '../node_modules/bulma-slider/dist/css/bulma-slider.min.css'
import '../node_modules/bulma-switch/dist/css/bulma-switch.min.css'

library.add(faThermometerThreeQuarters)
library.add(faAngleLeft)
library.add(faAngleRight)
library.add(faPlay)
library.add(faPause)
library.add(faNewspaper)
library.add(faBell)
library.add(faSave)
library.add(faCog)
library.add(faHeart)
library.add(faTwitter)

Vue.use(VueLocalStorage)
Vue.config.productionTip = false

Vue.component('fa-icon', FontAwesomeIcon)

Vue.filter('temperature', temperature)
Vue.filter('volume', volume)
Vue.filter('weight', weight)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
